import React, { useState, Fragment } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Popover, Tooltip } from "antd";
import { renderStatus } from "../../libs/deadlinesUtils";
import { FormattedMessage } from "react-intl";
import numeral from "numeral";
import moment from "moment";
import { usePermissions } from "../../customHooks";

const HeaderDetails = props => {
  const { myType } = props;
  const navigate = useNavigate();
  const [modalVisibledConnected, setModalVisibledConnected] = useState(false);
  const details = useSelector(state => state.detailsDocument.info.details);
  const currentPermissions = useSelector(state => state.currentPermissions);

  const { isPermissionsDeadlinesEInvoices } = usePermissions(currentPermissions);

  const getTotalPaidOrCollect = () => {
    const deadlinesConnected = details && details.deadlines;
    let totalPaidOrCollect = 0;
    if (deadlinesConnected.length > 0) {
      deadlinesConnected.map(deadline => {
        totalPaidOrCollect += deadline.payment.status === "due" ? deadline.totalAmount : 0;
        return totalPaidOrCollect;
      });
      return totalPaidOrCollect;
    }
    return undefined;
  };

  const getTotalImport = () => {
    let totalImport =
      details &&
      details.standardTags.find(el => {
        return el.key === "importoTotaleDocumento";
      });

    // se non è fattura elettronica allora sommo le scadenze
    if (!totalImport && details.deadlines.length > 0) {
      totalImport = details.deadlines.reduce(function(a, b) {
        return a + (parseFloat(b["totalAmount"]) || 0);
      }, 0);
    } else {
      totalImport = totalImport && totalImport.value.replace(/€/, "");
      totalImport = totalImport && totalImport.replace(".", "");
      totalImport = totalImport && totalImport.replace(",", ".");

      totalImport = parseFloat(totalImport);
    }
    return totalImport;
  };

  const stringifyImport = importNum => {
    return numeral(Math.abs(importNum)).format("0,0.00") + " €";
  };

  const renderDetailsRecap = () => {
    const totalImport = getTotalImport();
    const totalStringified = stringifyImport(totalImport);

    const numberInvoice = details.standardTags.find(el => {
      return el.key === "numero";
    });

    const dateInvoice = details.infoList.find(el => {
      return el.label === "Data documento";
    });

    const period = details.standardTags.find(el => {
      return el.key === "periodo";
    });
    const tax = details.standardTags.find(el => {
      return el.key === "PeriodoImposta";
    });

    const renderImporto = totalStringified => {
      return (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            fontWeight: "normal"
          }}
        >
          <div>Importo</div>
          <div style={{ fontSize: 20 }}>
            <b>{totalStringified}</b>
          </div>
        </div>
      );
    };

    return (
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "flex-end",
          justifyContent: "space-between",
          marginBottom: 40,
          color: "#152935",
          borderBottom:
            !details.einvoice && !totalImport && !period && !tax
              ? "0px"
              : "1px solid rgb(201, 217, 232)"
        }}
      >
        {details.einvoice ? (
          <React.Fragment>
            {numberInvoice && numberInvoice.value ? (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  fontWeight: "normal"
                }}
              >
                <div>
                  <div>Fattura num.</div>
                  <div style={{ fontSize: 20 }}>
                    <b>{numberInvoice.value}</b>
                  </div>
                </div>
              </div>
            ) : null}
            {dateInvoice && dateInvoice.value ? (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  fontWeight: "normal"
                }}
              >
                <div>Del</div>
                <div style={{ fontSize: 20 }}>
                  <b>
                    {
                      dateInvoice.value /* arriva gia stringa ad oggi moment(dateInvoice.value).format(DATE_FORMAT_FOR_DISPLAY)*/
                    }
                  </b>
                </div>
              </div>
            ) : null}
            {totalImport && renderImporto(totalStringified)}
          </React.Fragment>
        ) : (
          <React.Fragment>
            {period && period.value ? (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  fontWeight: "normal"
                }}
              >
                <div>
                  <div>Periodo di riferimento</div>
                  <div style={{ fontSize: 20 }}>
                    <b>{period.value}</b>
                  </div>
                </div>
              </div>
            ) : null}
            {tax && tax.value ? (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  fontWeight: "normal"
                }}
              >
                <div>
                  <div>Periodo di imposta</div>
                  <div style={{ fontSize: 20 }}>
                    <b>{tax ? tax.value : null}</b>
                  </div>
                </div>
              </div>
            ) : null}
            {totalImport ? renderImporto(totalStringified) : null}
          </React.Fragment>
        )}

        {details.deadlines && details.deadlines.length > 0 ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "column"
            }}
          >
            {renderDeadlinesDetails()}
          </div>
        ) : (
          <div />
        )}
      </div>
    );
  };

  const renderDeadlinesDetails = () => {
    if (
      !details.deadlines ||
      (details.deadlines && details.deadlines.length === 0)
    )
      return null;

    let arraydeadlines = [];
    details.deadlines.map(keyDeadline => {
      arraydeadlines.push(<div
        key={"rowDeadlines_" + keyDeadline.id}
        style={{ borderBottom: "1px solid rgba(21, 41, 53, 0.32)" }}
      >
        <div
          onClick={e => navigate("/scadenza/" + keyDeadline.id)}
          className="rowDetailDeadlines"
          style={{ display: "flex", padding: "16px", cursor: "pointer" }}
        >
          <div style={{ width: "80px" }}>
            {moment(keyDeadline.date).format("DD MMM YYYY")}
          </div>
          <div
            style={{ width: "90px", marginLeft: "10px", textAlign: "right" }}
          >
            {numeral(Math.abs(keyDeadline.totalAmount)).format("0,0.00") +
                " €"}
          </div>
          <div style={{ width: "150px", marginLeft: "30px" }}>
            {renderStatus(keyDeadline)}
          </div>
          <div style={{ marginLeft: "20px", flex: "1 1 auto" }}>
            <FontAwesomeIcon
              icon={["far", "arrow-right"]}
              style={{ color: "#0090d1", fontSize: "14px" }}
            />
          </div>
        </div>
      </div>);
      return arraydeadlines;
    });
    const totalPaidOrCollect = getTotalPaidOrCollect();
    const totalPaidOrCollectStringified = stringifyImport(totalPaidOrCollect);
    // Questo controllo serve per non mostrare la campanella se le scadenze collegate sono tutte fatture e non ho il permesso
    const deadlinesScopes =
      details.deadlines.length && details.deadlines.map(el => el.scope);
    const findElInvoices =
      deadlinesScopes &&
      deadlinesScopes.map(el => el !== "credit" && el !== "debit" && el !== "debt");
    const showPopover =
      (findElInvoices && findElInvoices.indexOf(true) > -1) ||
      isPermissionsDeadlinesEInvoices;

    return (
      <React.Fragment>
        {details.deadlines.length > 0 &&
          (showPopover || myType === "STUDIO") ? (
            <Popover
              onVisibleChange={e => {
                setModalVisibledConnected(!modalVisibledConnected);
              }}
              overlayClassName="deadlinesListPopover"
              placement="bottomLeft"
              title={"Scadenze"}
              visible={modalVisibledConnected}
              content={
                <div>
                  <div>{arraydeadlines}</div>
                  {totalPaidOrCollect !== 0 ?
                    <div
                      style={{
                        padding: "16px",
                        color: "#005075",
                        fontSize: "14px",
                        backgroundColor: "rgb(240, 250, 255)",
                        display: "flex",
                        fontWeight: "500"
                      }}
                    >

                      <Fragment>
                        <div style={{ width: "82px" }}>{totalPaidOrCollect > 0 ? <FormattedMessage id="deadlines.tocollect" /> : <FormattedMessage id="deadlines.due" />}</div>
                        <div
                          style={{
                            width: "90px",
                            marginLeft: "10px",
                            textAlign: "right"
                          }}
                        >
                          {totalPaidOrCollectStringified}
                        </div>
                      </Fragment>

                    </div> : null}
                </div>
              }
              trigger="click"
            >
              <Tooltip color={"rgb(0, 80, 117)"} placement="top" title={"Scadenze collegate"}>
                <div
                  style={{
                    width: "32px",
                    height: "32px",
                    cursor: "pointer",
                    textAlign: "center",
                    lineHeight: "32px",
                    color: "#0090d1",
                    fontSize: "16px"
                  }}
                  onClick={e => {
                    setModalVisibledConnected(true);
                  }}
                >
                  <FontAwesomeIcon
                    icon={["far", "alarm-clock"]}
                    style={{ color: "#0090d1", fontSize: "22px" }}
                  />
                </div>
              </Tooltip>
            </Popover>
          ) : null}
      </React.Fragment>
    );
  };
  return details ? renderDetailsRecap() : null;
};

export default HeaderDetails;
